export function SaveCSVWithBOM(fileName:string, text:string) {

    //BOM配列を作成
    let bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
    //BOMを付与してBlobを作成
    let blob = new Blob([bom,text], {type: "text/csv"});
    //ファイルURLを作成
    let url = URL.createObjectURL(blob);

    //ダウンロード用Elementを作成してダウンロードを実行
    let link = document.createElement('a');
    link.download = fileName;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

}